// arch-photo — Nikoh Royal preview card (n01).
//
// Nikoh ceremonial: outer warm-ink frame with a deep accent foil ring,
// inner cream page, and an arch-topped photo medallion crowned by a
// small geometric Samarkand mihrab. "NIKOH TO'YI" small-caps eyebrow,
// Marcellus names, small-cap date + venue caption. All colours come
// from LayoutCtx so any ceremonial-family template renders the same.
import { Photo, type LayoutCtx } from "./_shared";

export function ArchPhotoLayout({
  names,
  date,
  venue,
  accent,
  ink,
  bg,
  font,
  photo,
}: LayoutCtx) {
  const FOIL = `linear-gradient(135deg, ${accent} 0%, ${accent}aa 22%, ${accent} 45%, ${accent}aa 70%, ${accent} 100%)`;
  return (
    <div
      style={{
        position: "absolute",
        inset: 0,
        background: FOIL,
        padding: "5%",
        display: "flex",
      }}
    >
      <div
        style={{
          flex: 1,
          background: bg,
          color: ink,
          position: "relative",
          padding: "8%",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          textAlign: "center",
          boxShadow: `inset 0 0 0 1px ${accent}55, inset 0 0 0 5px ${bg}, inset 0 0 0 6px ${accent}55`,
        }}
      >
        <div
          style={{
            fontFamily: "var(--font-ui)",
            fontSize: 7,
            fontWeight: 700,
            letterSpacing: "0.4em",
            color: accent,
            marginBottom: "5%",
          }}
        >
          NIKOH TO&apos;YI
        </div>

        {/* Arched photo medallion (top half-circle, flat bottom) */}
        <div style={{ width: "60%", aspectRatio: "1 / 1.2", position: "relative", marginBottom: "5%" }}>
          <div
            style={{
              position: "absolute",
              inset: 0,
              borderTopLeftRadius: "50%",
              borderTopRightRadius: "50%",
              background: FOIL,
              padding: "5%",
              boxSizing: "border-box",
            }}
          >
            <div
              style={{
                width: "100%",
                height: "100%",
                borderTopLeftRadius: "50%",
                borderTopRightRadius: "50%",
                background: bg,
                padding: "4%",
                boxSizing: "border-box",
              }}
            >
              <div
                style={{
                  width: "100%",
                  height: "100%",
                  borderTopLeftRadius: "50%",
                  borderTopRightRadius: "50%",
                  overflow: "hidden",
                  position: "relative",
                }}
              >
                <Photo
                  src={photo}
                  style={{ position: "absolute", inset: 0, width: "100%", height: "100%" }}
                  fallback={
                    <div
                      style={{
                        position: "absolute",
                        inset: 0,
                        background: `radial-gradient(circle at 50% 60%, ${accent}33, ${bg})`,
                      }}
                    />
                  }
                />
              </div>
            </div>
          </div>
          {/* Mihrab keystone */}
          <svg
            viewBox="0 0 24 12"
            style={{ position: "absolute", top: "-6%", left: "50%", transform: "translateX(-50%)", width: "22%" }}
            aria-hidden
          >
            <path d="M2 12 L12 2 L22 12 Z" fill={accent} opacity="0.9" />
            <circle cx="12" cy="8" r="1.2" fill={bg} />
          </svg>
        </div>

        <div style={{ fontFamily: font, fontSize: 30, lineHeight: 1.05, fontWeight: 500, color: ink, letterSpacing: "0.02em" }}>
          {names}
        </div>

        <div style={{ flex: 1 }} />

        <div
          style={{
            fontFamily: "var(--font-ui)",
            fontSize: 6.5,
            fontWeight: 700,
            letterSpacing: "0.32em",
            color: accent,
            marginTop: "4%",
          }}
        >
          NIKOH TO&apos;YI · {date.toUpperCase()}
        </div>
        <div
          style={{
            fontFamily: "var(--font-ui)",
            fontSize: 6,
            fontWeight: 600,
            letterSpacing: "0.28em",
            color: `${ink}99`,
            marginTop: 6,
          }}
        >
          {venue.toUpperCase()}
        </div>
      </div>
    </div>
  );
}
